import React from 'react';
import { Star } from 'lucide-react';

const LABELS = ['', 'Poor', 'Below Average', 'Average', 'Good', 'Excellent'];

const StarRating = ({ value, onChange, disabled, size = 'md', label = 'Rating' }) => {
  const sizes = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-8 h-8' };
  const s = sizes[size] || sizes.md;

  return (
    <div className="flex gap-1" role="radiogroup" aria-label={label}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={value === star}
          aria-label={`${star} star — ${LABELS[star]}`}
          disabled={disabled}
          onClick={() => onChange?.(star)}
          className={`transition-all duration-150 ${disabled ? 'cursor-default' : 'cursor-pointer hover:scale-110 active:scale-95'}`}
        >
          <Star
            className={`${s} transition-colors ${
              star <= (value || 0)
                ? 'fill-amber-400 text-amber-400'
                : 'fill-transparent text-pw-border-variant'
            }`}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
